import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import ChooseUserSelect from '../../chooseUserBuy/chooseUser/chooseUserSelect/chooseUserSelect';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import CourseDetail from '../../coursDetail/courseDetail';
import { API_URL } from '../../../config';
import axios from 'axios';
import ApiService from '../../../services/ApiService';
import NewPerson from '../../chooseUserBuy/addNewConectedPerson/newPerson';
import { setUsersPayer } from '../../../reducers/reposReducers';
import Modal from '../../../components/Elements/modal/modal';




 
const ChooseCampUser = (props) => {
  const getSubaccountsURL = `${API_URL}GetSubaccounts`;
  const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
  const apiService = ApiService.getInstance();
  const [res, setRes] = useState([]);
  const [resUser, setResUser] = useState([]);
  const [getResponse, setGetResponse] = useState(0);
  const [allert, setallert] = useState(false);
  let [modalClass, showModal] = useState("modal hidden")

  const [selectUsersId, setSelectUsersId] = useState("");
  const [isRelatedPerson, setIsReletedPerson] = useState(false);
  const userName = localStorage.getItem('userName')
  const history = useHistory();
  let userID =  localStorage.getItem('usersID')
  const usersPayerDispatch = useDispatch();
    function goToSummary(){
   
   
      props.next()
    }
  



  function checkIsConectedPerson (id, isReleted, fullUser){
  
    if(isReleted == undefined){
      setIsReletedPerson(false)
    }else{
    setIsReletedPerson(isReleted)
    }
    setSelectUsersId(id);
    props.setParcipient(fullUser)
    localStorage.setItem('selectedPartipient', JSON.stringify(fullUser));
  }
  function changeModal(){
    if(modalClass == "modal hidden"){
       showModal("modal")
    }else{
       showModal("modal hidden")
    }}
  
  useEffect(()=>{

    if(selectUsersId == ""&&props.parcipient == undefined){
      
    setSelectUsersId(userID)}else if(
        props.parcipient != undefined
    ){
     
        setSelectUsersId(props.parcipient)
    }
    let u = Date.now().toString(16) + Math.random().toString(16) + '0'.repeat(16);
    let mongoguid =  [u.substr(0,8), u.substr(8,4), '4000-8' + u.substr(13,3), u.substr(16,12)].join('-');
    localStorage.setItem("guid",mongoguid)
    props.setTrackigId(mongoguid)
  },[])
  
  useEffect(()=>{
    if(props.userId != undefined){
      setSelectUsersId(props.userId)
    }
},[props.userId])
    return <> 
      <div className={modalClass}>
      <Modal close={changeModal}>
      <NewPerson onRefresh={props.tegetRelationsUsersst} close={changeModal}></NewPerson>
      </Modal>
    </div>
    <div className='wrraper'>

 <div className='chooseUser_selectUSer'>
 <CustomTittle>Wybierz uczestnika obozu</CustomTittle>
   <p className='forWho'>Dla kogo kupujesz obóz?</p>
    {selectUsersId == userID?
    <ChooseUserOption option={props.option} userName={userName  } isChekcked={true} idUsers={props.option.usersID} onCheck={checkIsConectedPerson} label="Dla siebie"/>:<ChooseUserOption  idUsers={props.option.usersID} isChekcked={false} option={props.option} userName={userName} onCheck={checkIsConectedPerson}  label="Dla siebie"/>}
    <ChooseUserSelect isRelatedPerson={selectUsersId != userID}  showModal={changeModal} selectUsersId={selectUsersId} onCheck={checkIsConectedPerson} setOption={props.setConectedPerson}  option={props.conectedPerson} label="Dla osoby powiązanej"/>
    <CustomButtons clickFunction={goToSummary} classButton="solid" size="big">PRZEJDŹ DALEJ</CustomButtons>
 </div>
  <div className='columDetials'>

   <div className='columDetials_wrapper'>
                <CustomTittle>Szczegóły zamówienia  </CustomTittle>
                <CourseDetail wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
    </div>
  </div>
  </div>
    </>;
    }

export default ChooseCampUser;